// =============================================================================
// SHOP FRONT MAKERS — SITE CONFIGURATION
// -----------------------------------------------------------------------------
// NOTE FOR OWNER: All contact details below are CLEARLY MARKED PLACEHOLDERS.
// Replace them with your authentic business details before going live.
// Do NOT ship placeholder social/contact links to production.
// =============================================================================

export const CONTACT = {
  phone: "085 846 8599",
  phoneHref: "tel:+353858468599",
  whatsapp: "085 846 8599",
  whatsappHref: "https://wa.me/353858468599",
  email: "info@maximall.ie",
  emailHref: "mailto:info@maximall.ie",
  address: "Unit 8, Rahilla Glebe, Dunmurry Hill, Co. Kildare, R51 W966",
  responseNote: "We typically respond within 2 business hours.",
};

export const SOCIAL = {
  facebook: "https://facebook.com/profile.php?id=61561614332696",
  instagram: "https://www.instagram.com/shopfrontmakers.ie/",
  tiktok: "https://www.tiktok.com/@maximalladvs",
};

export const NAV_LINKS = [
  { name: "Home", href: "/", id: "nav-home" },
  { name: "Services", href: "/services", id: "nav-services" },
  { name: "Projects", href: "/projects", id: "nav-projects" },
  { name: "Contact", href: "/contact", id: "nav-contact" },
];

export const IMAGES = {
  heroPrimary: "/assets/hero-reshape.jpg",
  heroSecondary: "/assets/hero-mrfade.jpg",
};

export const SERVICES = [
  {
    id: "shopfront-design-build",
    number: "01",
    title: "Shopfront Design & Build",
    tagline:
      "End-to-end shopfront design and construction — from concept sketches and 3D renders through planning support to a fully installed, eye-catching facade.",
    features: ["3D CAD & Photorealistic Renders", "Council & Planning Support", "Tricoya, Hardwood, ACM & Steel", "Full Structural Glazing & Fascia"],
    turnaround: "3–5 Weeks",
    image: "/assets/shopfront-isales.jpg",
    imageAlt: "iSales Dublin shopfront design and window graphics by Shop Front Makers",
    imagePosition: "object-top",
  },
  {
    id: "illuminated-signs-led",
    number: "02",
    title: "Illuminated Signs & LED Displays",
    tagline:
      "3D halo-lit built-up lettering, bespoke neon, edge-lit lightboxes and low-energy LED modules engineered to make your brand glow day and night.",
    features: ["3D Halo-Lit & Face-Lit Letters", "Marine-Grade Stainless Steel", "Custom Flex Neon & Acrylic", "IP67 Weatherproof Drivers"],
    turnaround: "7–12 Days",
    image: "/assets/illuminated-chinteriors.jpg",
    imageAlt: "C.H. Interiors halo-lit built-up lettering by Shop Front Makers",
  },
  {
    id: "vehicle-wraps",
    number: "03",
    title: "Vehicle Wraps",
    tagline:
      "Turn your commercial fleet into mobile billboards with cast vinyl wraps, partial wraps and reflective safety branding applied in a controlled bay.",
    features: ["Full & Partial Cast Vinyl", "Fleet Uniformity Management", "Anti-Scratch Matte/Gloss Laminates", "Reflective Safety Chevrons"],
    turnaround: "2–4 Days / Vehicle",
    image: "/assets/vehicle-ipx.jpg",
    gallery: [
      { src: "/assets/vehicle-ipx.jpg", label: "IPX Roofing & Gutters — full commercial van wrap" },
      { src: "/assets/vehicle-autovan.jpg", label: "AutoVan Mobile Tyres — full commercial van wrap" },
    ],
  },
  {
    id: "window-graphics",
    number: "04",
    title: "Window Graphics",
    tagline:
      "Privacy etch, solar control films, one-way vision perforated graphics and promotional decals — precisely cut and fitted to your glazing.",
    features: ["Frosted & Dusted Crystal Film", "One-Way Vision Contravision", "Reg-Compliant Manifestation", "UV Fade-Resistant Inks"],
    turnaround: "48–72 Hours",
    image: "/assets/window-dominos.jpg",
    imageAlt: "Domino's storefront window graphics by Shop Front Makers",
    gallery: [
      { src: "/assets/window-dominos.jpg", label: "Domino's storefront window graphics by Shop Front Makers" },
      { src: "/assets/window-mycoffee.jpg", label: "My Coffee window decal graphics by Shop Front Makers" },
    ],
  },
  {
    id: "printing-services",
    number: "05",
    title: "Printing Services",
    tagline:
      "Large-format outdoor banners, hoarding panels, rigid signage, pull-up stands and branded point-of-sale displays printed on durable media.",
    features: ["UV Flatbed Direct-to-Substrate", "Recyclable Eco Media", "Up to 3.2m Seamless Width", "Accurate Colour Profiling"],
    turnaround: "24–48 Hours",
    image: "/assets/printing-workshop.jpg",
    caption: "In-house large-format printing, finishing and custom graphics production.",
  },
  {
    id: "interior-shop-transformation",
    number: "06",
    title: "Interior Shop Transformation",
    tagline:
      "Atmospheric retail fit-outs: branded feature walls, illuminated menus and wayfinding, bespoke counters and durable high-traffic finishes.",
    features: ["Feature Brand & Acoustic Walls", "Illuminated Wayfinding", "Bespoke POS & Reception Joinery", "High-Traffic Surface Protection"],
    turnaround: "2–3 Weeks",
    image: "/assets/interior-decoplants.jpg",
    imageAlt: "DecoPlants feature wall and interior signage by Shop Front Makers",
    imagePosition: "object-center",
  },
  {
    id: "full-shop-transformation",
    number: "07",
    title: "Full Shop Transformation",
    tagline:
      "The flagship turnkey overhaul — exterior facade, interior fit-out and brand unification delivered under one contract and a single project lead.",
    features: ["One Contract & Dedicated PM", "No Subcontractor Blame Game", "Off-Hours Minimal Downtime", "Design + Build + Install as One"],
    turnaround: "Turnkey Programme",
    image: "/assets/full-aminbarbers.jpg",
    imageAlt: "Amin Barbers built-up shopfront lettering by Shop Front Makers",
  },
];

// Sample project cards — EASY TO REPLACE. Swap image/title/copy freely.
export const PROJECTS = [
  {
    id: "proj-1",
    title: "Biryani House",
    industry: "Restaurant & Takeaway",
    service: "Shopfront signage & window graphics",
    category: "Facades",
    outcome: "Bright yellow fascia sign with branded food-window graphics.",
    image: "/assets/biryani-house.jpg",
    tags: ["Fascia Sign", "Window Graphics", "Branded Frontage"],
  },
  {
    id: "proj-2",
    title: "Alesia Beauty Salon",
    industry: "Beauty & Hair Salon",
    service: "Illuminated 3D lettering & salon shopfront signage",
    category: "Interiors",
    outcome: "Gold 3D lettering and logo with warm illuminated trim, set against the real salon interior.",
    image: "/assets/alessia-beauty.jpg",
    tags: ["Gold 3D Lettering", "Illuminated Trim", "Salon Signage"],
  },
  {
    id: "proj-3",
    title: "Maximall",
    location: "Main St, Celbridge, Co. Kildare, W23 W2V6",
    industry: "Retail & Commercial Branding",
    service: "3D lettering, fascia signage & storefront branding",
    category: "Illuminated",
    outcome: "3D lettering, fascia signage and full storefront branding — designed, produced and installed.",
    image: "/assets/maximall-storefront.jpg",
    gallery: [
      { src: "/assets/maximall-storefront.jpg", label: "Finished storefront & fascia signage" },
      { src: "/assets/maximall-signage.jpg", label: "Close-up: 3D lettering installation" },
    ],
    tags: ["3D Lettering", "Fascia Signage", "Storefront Branding"],
  },
  {
    id: "proj-4",
    title: "Van & Car Tyres",
    industry: "Mobile Tyre Service",
    service: "Commercial vehicle wrap & high-visibility branding",
    category: "Vehicle Wraps",
    outcome: "High-visibility yellow-and-black wrap graphics across the mobile tyre-service van.",
    image: "/assets/vantyres-wrap.jpg",
    tags: ["Vehicle Wrap", "High-Visibility Graphics", "Van Branding"],
  },
];

export const PROJECT_CATEGORIES = ["All", "Facades", "Illuminated", "Interiors", "Vehicle Wraps"];

// Real, completed vehicle-wrap photos (shown as finished work, NOT before/after).
export const RECENT_VEHICLE_WRAPS = [
  { src: "/assets/vehicle-ipx.jpg", label: "IPX Roofing & Gutters — full van wrap" },
  { src: "/assets/vehicle-autovan.jpg", label: "AutoVan Mobile Tyres — full van wrap" },
];

// Before/After categories. Transformation categories use CLEARLY LABELLED placeholder
// panels until real matched pairs are supplied. Vehicle Wraps intentionally uses a real
// "Recent Vehicle Wraps" gallery instead of a before/after pair.
// TODO(owner): when a real matched pair arrives, add { before: "/assets/...", after: "/assets/..." }
// to the relevant category and the slider will use the photos automatically.
export const BEFORE_AFTER_CATEGORIES = [
  {
    id: "shopfront",
    name: "Shopfront Transformations",
    items: [
      {
        id: "matsu-ramen",
        title: "Matsu Ramen",
        copy: "A complete shopfront redesign for a Japanese ramen restaurant — new facade, illuminated signage and frontage.",
        before: "/assets/matsu-before.jpg",
        after: "/assets/matsu-after.jpg",
        beforeLabel: "Before",
        afterLabel: "After",
      },
      {
        id: "blooming-you-beauty",
        title: "Blooming You Beauty",
        copy: "A concept direction for a refined beauty-studio facade, signage and window graphics.",
        before: "/assets/blooming-existing.jpg",
        after: "/assets/blooming-proposed.jpg",
        beforeLabel: "Existing Shopfront",
        afterLabel: "Proposed Design",
        note: "Before / Proposed Design concept — not a completed installation",
      },
    ],
  },
  { id: "window", name: "Window Decals & Graphics" },
  { id: "interior", name: "Interior Transformations" },
  { id: "vehicle", name: "Vehicle Wraps", type: "gallery" },
];

export const MANIFESTO = [
  {
    chapter: "01",
    title: "Design With Intent",
    description:
      "We don't just stick signs onto walls. We design proportional facades that respect structural lines, planning guidelines and the psychology of footfall.",
  },
  {
    chapter: "02",
    title: "In-House Fabrication",
    description:
      "Routing, welding, letter-bending and finishing happen under one roof in our Irish workshop — no middleman markup, no lost detail.",
  },
  {
    chapter: "03",
    title: "Our Own Install Crews",
    description:
      "Our teams erect, wire, glaze and seal your shopfront. Safe Pass trained and insured, for genuine peace of mind from start to finish.",
  },
  {
    chapter: "04",
    title: "Design + Build as One",
    description:
      "One team owns design, production and construction. No subcontractor blame game — one point of contact, one standard, one result.",
  },
];

export const STATS = [
  { value: "150+", label: "Irish Shopfronts Delivered" },
  { value: "1", label: "Team: Design + Build + Install" },
  { value: "7", label: "Core Services In-House" },
  { value: "100%", label: "Nationwide Coverage" },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title).concat(["General Enquiry"]);
